<template>
  <v-dialog v-model="modalShow" width="500">
    <v-card>
      <v-card-title class="headline" primary-title>
        <div class="d-flex flex-fill">
          <div>
            <small>{{ title ? title : commonTitle }}</small>
          </div>
          <div class="ml-auto cursor" @click="hide()">
            <v-icon style="color:#0c0c0c">mdi-close</v-icon>
          </div>
        </div>
      </v-card-title>

      <v-divider color="#e6e6e6"></v-divider>

      <v-card-text class="pa-5">
        <TextFieldComponent
          ref="pwdInput"
          :type="showPassword ? 'text' : 'password'"
          :label="$t('labels.txnPwd')"
          :rules="rules.txnPwd"
          :outlined="true"
          :icon="showPassword ? 'visibility' : 'visibility_off'"
          :model.sync="txnPwd"
          @keyup.enter.native="submit"
          @append="showPassword = !showPassword"
        ></TextFieldComponent>

        <div class="text-right">
          <v-btn class="no-shadow btn-common-outline" outlined depressed :loading="loading" @click="submit">{{
            btnText ? btnText : commonBtnText
          }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import TextFieldComponent from '@/components/Form/TextField';

export default {
  props: {
    btnText: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      // Txn Pwd
      type: String,
      default: ''
    }
  },
  components: {
    TextFieldComponent
  },
  data() {
    return {
      modalShow: false,
      commonTitle: this.$t('labels.txnPwd'),
      commonBtnText: this.$t('actions.submit'),
      txnPwd: '',
      rules: {
        txnPwd: {
          required: true,
          regex: /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{6,20}$/
        }
      },
      showPassword: false
    };
  },
  watch: {
    show: function() {
      this.modalShow = this.show;
      if (!this.show) {
        // Clear input and validation state when modal is closed
        this.$emit('input', '');
      }
    },
    modalShow: function(val) {
      this.$emit('update:show', val);
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  mounted() {
    this.modalShow = true;
    setTimeout(() => {
      this.$refs.pwdInput.focus();
    }, 200);
  },
  methods: {
    submit() {
      this.$emit('submit', this.txnPwd);
    },
    hide() {
      this.modalShow = false;
    }
  }
};
</script>
<style lang="stylus" scoped></style>
